import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-results-info',
  standalone: true,
  imports: [],
  template: `
    @if (showInfo) {
      <span class="results-text">
        {{ displayText }}
      </span>
    }
  `,
  styles: [
    `
      .results-text {
        font-size: 14px;
        color: #6b7280;
        font-family: var(
          --ukg_sys_fontFamily_primaryTight,
          -apple-system,
          BlinkMacSystemFont,
          'Segoe UI',
          sans-serif
        );
      }
    `,
  ],
})
export class ResultsInfoComponent {
  @Input() pageNumber = 1;
  @Input() pageSize = 10;
  @Input() totalCount = 0;
  @Input() filteredDataLength: number | null = null;
  @Input() itemLabel = 'items';

  get showInfo(): boolean {
    return (
      this.totalCount > 0 ||
      (this.filteredDataLength !== null && this.filteredDataLength === 0)
    );
  }

  get displayText(): string {
    if (this.filteredDataLength !== null) {
      if (this.filteredDataLength > 0) {
        const startRow = this.pageSize * (this.pageNumber - 1) + 1;
        const endRow = Math.min(
          this.filteredDataLength + this.pageSize * (this.pageNumber - 1),
          this.totalCount
        );
        return `Showing ${startRow} - ${endRow} of ${this.totalCount} ${this.itemLabel}`;
      } else {
        return `Showing 0 of ${this.totalCount} ${this.itemLabel}`;
      }
    }

    const startRow = (this.pageNumber - 1) * this.pageSize + 1;
    const endRow = Math.min(this.pageNumber * this.pageSize, this.totalCount);
    return `Showing ${startRow} - ${endRow} of ${this.totalCount} ${this.itemLabel}`;
  }
}
